<template>
    <div class="d-flex">
        <input
            class="file-upload-element"
            type="file"
            ref="documentUploadRef"
            @change="handleFileChange"
            accept="application/pdf"
        />
        <div v-if="loadingFileName" class="align-items-sm-baseline d-flex">
            <div class="circle-progress">
                <CircleProgress
                    v-if="loading"
                    :percent="uploadPercent"
                    fillColor="#ffc700"
                />
            </div>
            <div class="d-flex align-items-center ps-2">
                <div class="text-truncate mb-1 fw-bold">{{ loadingFileName }}</div>
                <i
                    class="bi bi-x-square fs-1 text-danger mb-0 ms-2"
                    style="cursor: pointer"
                    @click="removeFile"
                ></i>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { storage } from "@/firebase";
import {
    ref as fbRef,
    uploadBytesResumable,
    getDownloadURL,
} from "firebase/storage";
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";

const props = defineProps({
    tenant: Number,
});

const documentUploadRef = ref(null);
const uploadPercent = ref(0);
const loading = ref(false);
const loadingFileName = ref("");
const uploadFile = ref(null);

const emit = defineEmits(["uploadedDocument", "updateLoading"]);

const browseDocument = () => {
    if (!documentUploadRef.value) {
        console.warn("document upload not mounted yet");
    }
    setTimeout(() => {
        documentUploadRef.value.click();
    }, 0);
};
const reset = () => {
    if (!documentUploadRef.value) {
        console.warn("document upload not mounted yet");
    }
    loading.value = false;
    loadingFileName.value = "";
    uploadPercent.value = 0;
    if (uploadFile.value) {
        uploadFile.value.cancel();
        uploadFile.value = null;
    }
    documentUploadRef.value.value = "";
    emit("uploadedDocument", null);
};

const removeFile = () => {
    reset();
};

const handleFileChange = (event) => {
    const files = event.target.files;
    if (!files || !files.length) {
        reset();
        return;
    }
    const file = files[0];
    loadingFileName.value = file.name;
    loading.value = true;
    try {
        const now = new Date();
        const filename = file.name;
        const fileRef = `${filename + "-" + now.getTime()}`;
        const path = `tenants/${props.tenant}/documents/${fileRef}`;
        const storageRef = fbRef(storage, path);
        uploadPercent.value = 10;
        uploadFile.value = uploadBytesResumable(storageRef, file);
        uploadFile.value.on(
            "state_changed",
            (snapshot) => {
                const progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (progress) uploadPercent.value = progress;
            },
            (error) => {
                console.error("Error uploading file:", error);
                reset();
            },
            async () => {
                const url = await getDownloadURL(uploadFile.value.snapshot.ref);
                emit("uploadedDocument", { filename, url });
                loading.value = false;
            }
        );
    } catch (err) {
        console.error(err);
    }
};

watch(loading, () => {
    emit("updateLoading", loading.value);
});

defineExpose({
    browseDocument,
    reset,
});
</script>

<style lang="scss" scoped>
.file-upload-element {
    width: 0px;
    height: 0px;
    opacity: 0;
}
.vue3-circular-progressbar {
    width: 25px !important;
    height: 25px !important;
}

.circle-progress {
    width: 25px !important;
    height: 25px !important;
}
</style>
